module.exports = __webpack_public_path__ + "static/media/aboutUs.1271fd61.JPG";